import jQuery from './jquery-2.2.0';

window.RadResponder = window.RadResponder || {};


//--------------------------------------------------------
// CSRF Functions
//--------------------------------------------------------
RadResponder.csrfTokenHeaderName = "X-CSRF-Token";
RadResponder.csrfTokenMetaTagSelector = 'meta[name="csrf-token"]';
RadResponder.csrfToken = null;
RadResponder.setCsrfToken = function (securityToken) {
    RadResponder.csrfToken = securityToken;
    jQuery.ajaxPrefilter(function (options, _, xhr) {
        if (!xhr.crossDomain)
            xhr.setRequestHeader(RadResponder.csrfTokenHeaderName, RadResponder.csrfToken);
    });
};
RadResponder.updateCsrfToken = function (securityToken) {
    //update the meta tag
    $(RadResponder.csrfTokenMetaTagSelector).attr("content", securityToken);

    //update the variable
    RadResponder.csrfToken = securityToken;
};


